module.exports = __webpack_public_path__ + "static/AtlasGold-f7a70d66ae1ba66211690fa045393fd1.jpg";